import { render, staticRenderFns } from "./ThumbnailSlotLargeVertical.vue?vue&type=template&id=31b5c78c"
import script from "./ThumbnailSlotLargeVertical.vue?vue&type=script&lang=js"
export * from "./ThumbnailSlotLargeVertical.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports